import { gql } from "@apollo/client"
import { RegisterSystemTask } from "event-definitions"
import { createEvent } from "library/local-events/index.mjs"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { Frag } from "lib/@components/slot/frag"
import { mutate } from "lib/graphql/mutate"
import { TaskEditor } from "slot-definitions"

const ClearTranslationCache = createEvent("clearTranslationCache")

RegisterSystemTask.handleOnce(({ tasks }) => {
    tasks.push({
        name: "Clear Translation Cache",
        event: ClearTranslationCache.eventName,
        params: {},
    })
})

TaskEditor(ClearTranslationCache.eventName).plug(replaceAllWith(<Frag />))

ClearTranslationCache.handleOnce(async () => {
    await mutate(
        gql`
            mutation ClearTranslationCache {
                clearTranslationCache
            }
        `,
        {},
        { returns: "clearTranslationCache" }
    )
})
